import jwtDecode from 'jwt-decode';
import idx from 'idx';
import { normalize } from 'normalizr';
import { change } from 'redux-form';
import Cookie from 'js-cookie';

import { getTokenExpirationDate } from 'helpers';
import * as types from '../constants/actionTypes';
import { JWT_TOKEN_KEY, API_URL } from '../constants';
import { authFetch } from '../api';
import { replaceFormState } from '../actions/form';
import { addEntities } from '../actions/entities';

const authLoginRequest = () => ({
	type: types.AUTH_LOGIN_REQUEST,
});

const authLoginSuccess = token => {
	const expires = getTokenExpirationDate();

	Cookie.set(JWT_TOKEN_KEY, token, {
		expires,
	});

	const tokenData = jwtDecode(token);

	return {
		type: types.AUTH_LOGIN_SUCCESS,
		payload: {
			text: '',
			token,
			user: idx(tokenData, _ => _.user),
			eComToken: idx(tokenData, _ => _.ecom_token),
		},
	};
};

const authLoginFailure = error => {
	Cookie.remove(JWT_TOKEN_KEY);

	return {
		type: types.AUTH_LOGIN_FAILURE,
		payload: {
			text: error,
		},
	};
};

const doLogout = (message = 'You have successfully been logged out.') => ({
	type: types.AUTH_LOGOUT,
	payload: {
		text: message,
	},
});

export function logout(
	message = 'You have successfully been logged out.',
	redirectTo = '/'
) {
	return dispatch => {
		Cookie.remove(JWT_TOKEN_KEY);

		dispatch(doLogout(message));
		window.location.replace(redirectTo);
	};
}

export function authVerifyToken(token) {
	return dispatch => {
		try {
			jwtDecode(token);
			return dispatch(authLoginSuccess(token));
		} catch (e) {
			return dispatch(authLoginFailure('Invalid token.'));
		}
	};
}

export function login(history, successUrl = '/', formKey = false) {
	return (dispatch, getState) => {
		const form = getState().form;

		const { username, password } = form.loginForm.values;

		dispatch(authLoginRequest());

		fetch(API_URL + 'auth', {
			method: 'post',
			body: JSON.stringify({
				username,
				password,
			}),
		})
			.then(res => res.json())
			.then(res => {
				if (!idx(res, _ => _.token)) {
					dispatch(change('loginForm', 'password', ''));

					return idx(res, _ => _.error)
						? dispatch(authLoginFailure(res.error))
						: dispatch(authLoginFailure('Bad login.'));
				}

				try {
					jwtDecode(res.token);

					dispatch(authLoginSuccess(res.token));

					if (formKey && Cookie.get(formKey)) {
						const formState = JSON.parse(Cookie.get(formKey));
						dispatch(replaceFormState(formState));
					}

					return history.push(successUrl);
				} catch (error) {
					return dispatch(authLoginFailure('Invalid token.'));
				}
			})
			.catch(error => dispatch(authLoginFailure(error.message)));
	};
}

const loggedInUserFetchRequest = () => ({
	type: types.USER_LOGGED_IN_FETCH_REQUEST,
});

const loggedInUserFetchSuccess = user => ({
	type: types.USER_LOGGED_IN_FETCH_SUCCESS,
	payload: {
		user,
	},
});

const loggedInUserFetchFailure = (message = 'Something went wrong.') => ({
	type: types.USER_LOGGED_IN_FETCH_FAILURE,
	payload: {
		message,
	},
});

export function getLoggedInUser() {
	return (dispatch, getState, { schema }) => {
		const state = getState();
		const { token } = state.auth;

		if (!token) return dispatch(logout());

		const { user } = jwtDecode(token);

		dispatch(loggedInUserFetchRequest());

		authFetch(`users/${user.id}`, {}, token, dispatch)
			.then(res => res.json())
			.then(res => {
				if (!idx(res, _ => _.user)) {
					return idx(res, _ => _.error)
						? dispatch(loggedInUserFetchFailure(res.error))
						: dispatch(loggedInUserFetchFailure('Something went wrong.'));
				}

				const data = normalize([res.user], [schema.user]);
				dispatch(addEntities(data.entities));
				return dispatch(loggedInUserFetchSuccess(data.result[0]));
			})
			.catch(error => dispatch(loggedInUserFetchFailure(error.message)));
	};
}



// WEBPACK FOOTER //
// ./src/actions/auth.js